import React, { useEffect } from 'react';
import Main from './components/Main';
import { useGetUserList } from '@src/components/user-management/hooks';
import { ErrorBoundary } from '@components/common';
import { panelVisibleAtom } from './store';
import { useAtom } from 'jotai';

export const OPEN_USER_MANAGEMENT_EVENT = 'open-user-management';

export const UserManagement = () => {
  const [visible, setVisible] = useAtom(panelVisibleAtom);

  const { refetch: refetchUserList } = useGetUserList({
    enabled: visible,
  });

  useEffect(() => {
    const handleOpenUserManagement = () => {
      setVisible(true);
      refetchUserList();
    };
    window.addEventListener(OPEN_USER_MANAGEMENT_EVENT, handleOpenUserManagement);
    return () => {
      window.removeEventListener(OPEN_USER_MANAGEMENT_EVENT, handleOpenUserManagement);
    };
  }, [refetchUserList, setVisible]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('open') === 'user-management') {
      setVisible(true);
      refetchUserList();
      params.delete('open');
      const remaining = params.toString();
      const cleanUrl = window.location.pathname + (remaining ? `?${remaining}` : '');
      window.history.replaceState(null, '', cleanUrl);
    }
  }, [setVisible, refetchUserList]);

  return (
    <div
      id="user-management-container"
      data-testid="user-management"
      data-ifc-event={OPEN_USER_MANAGEMENT_EVENT}
    >
      <ErrorBoundary>
        <Main />
      </ErrorBoundary>
    </div>
  );
};

export default React.memo(UserManagement);
